export default __webpack_public_path__ + "static/media/apple-app-iphone-store.8c177f2d.png";